import { ImageByLocation } from "../../../../../../Core/ProductDetails/ProductDetailsImages/ProductDetailsCustomBox/ProductDetailsCustomBox";
import A1 from "./A/1.png";
import A2 from "./A/2.png";
import A3 from "./A/3.png";
import B1 from "./B/1.png";
import B2 from "./B/2.png";
import B3 from "./B/3.png";
import C1 from "./C/1.png";
import C2 from "./C/2.png";
import D1 from "./D/1.png";
import D2 from "./D/2.png";
import D3 from "./D/3.png";
import E1 from "./E/1.png";
import E2 from "./E/2.png";
import E3 from "./E/3.png";
import F1 from "./F/1.png";
import F2 from "./F/2.png";
import F3 from "./F/3.png";
import G1 from "./G/1.png";
import G2 from "./G/2.png";
import G3 from "./G/3.png";
import H1 from "./H/1.png";
import H2 from "./H/2.png";
import H3 from "./H/3.png";
import I1 from "./I/1.png";
import I2 from "./I/2.png";
import I3 from "./I/3.png";

const saintValentinTemplate: Array<ImageByLocation> = [
  {
    G: G1,
    H: H1,
    I: I1,
    C: C1,
    F: F1,
    A: A1,
    B: B1,
    D: D1,
    E: E1,
  },
  {
    G: G2,
  },
  {
    C: C2,
  },
  {
    F: F2,
  },
  {
    A: A2,
  },
  {
    I: I2,
  },
  {
    H: H2,
  },
  {
    D: D2,
  },
  {
    B: B2,
  },
  {
    E: E2,
  },
  {
    D: D3,
  },
  {
    A: A3,
  },
  {
    B: B3,
  },
  {
    E: E3,
  },
  {
    F: F3,
  },
  {
    G: G3,
    I: I3,
    H: H3,
  },
];

export default saintValentinTemplate;
